/**
* 左边菜单
*/ 
<template>
  <el-menu default-active="2" :collapse="collapsed" collapse-transition router :default-active="$route.path" unique-opened class="el-menu-vertical-demo" background-color="#334157" text-color="#fff" active-text-color="#ffd04b">
    <div class="logobox">
      <span style='color:#fff'>小胡童后台</span>
      <img class="logoimg" src="../assets/img/logo.png" alt="">
    </div>
    <el-submenu v-for="menu in allmenu" :key="menu.menuid" :index="menu.menuname">
      <template slot="title">
        
        <i class="iconfont" :class="menu.icon"></i>
        <span>{{menu.menuname}}</span>
      </template>
      <el-menu-item-group>
        <el-menu-item v-for="chmenu in menu.menus" :index="chmenu.url" :key="chmenu.menuid">
          <i class="iconfont" :class="chmenu.icon"></i>
          <span>{{chmenu.menuname}}</span>
        </el-menu-item>
      </el-menu-item-group>
    </el-submenu>
  </el-menu>
</template>
<script>
import { menu } from '../api/userMG'
export default {
  name: 'leftnav',
  data() {
    return {
      collapsed: false,
      allmenu: []
    }
  },
  // 创建完毕状态(里面是操作)
  created() {
    // 获取用户角色
    const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}')
    const userRole = userInfo.role || ''
    
    // 基础菜单数据
    let menuData = [
      {
        menuid: 1,
        icon: 'li-icon-xiangmuguanli',
        menuname: '门店管理',
        hasThird: null,
        url: null,
        menus: [
          {
            menuid: 2,
            icon: 'icon-cat-skuQuery',
            menuname: '店铺管理',
            hasThird: 'N',
            url: '/shop/Index',
            menus: null
          },
          {
            menuid: 3,
            icon: 'icon-cat-skuQuery',
            menuname: '用户余额管理',
            hasThird: 'N',
            url: '/shop/Balance',
            menus: null
          }
        ]
      },
      {
        menuid: 3,
        icon: 'li-icon-dingdanguanli',
        menuname: '订单管理',
        hasThird: null,
        url: null,
        menus: [
          {
            menuid: 31,
            icon: 'icon-order-manage',
            menuname: '棋牌订单',
            hasThird: 'N',
            url: '/order/Qp',
            menus: null
          },
          {
            menuid: 32,
            icon: 'icon-order-manage',
            menuname: '台球订单',
            hasThird: 'N',
            url: '/order/Tq',
            menus: null
          },
          {
            menuid: 33,
            icon: 'icon-order-manage',
            menuname: '充值订单',
            hasThird: 'N',
            url: '/order/Charge',
            menus: null
          },
          {
            menuid: 34,
            icon: 'icon-order-manage',
            menuname: '团购券订单',
            hasThird: 'N',
            url: '/order/Tuan',
            menus: null
          },
        ]
      },
      {
        menuid: 5,
        icon: 'li-icon-dingdanguanli',
        menuname: '设备管理',
        hasThird: null,
        url: null,
        menus: [
          {
            menuid: 51,
            icon: 'icon-order-manage',
            menuname: '智控主板',
            hasThird: 'N',
            url: '/device/Board',
            menus: null
          },
          {
            menuid: 52,
            icon: 'icon-order-manage',
            menuname: '空调伴侣',
            hasThird: 'N',
            url: '/device/Air',
            menus: null
          },
          {
            menuid: 53,
            icon: 'icon-order-manage',
            menuname: '蓝牙门锁',
            hasThird: 'N',
            url: '/device/Lock',
            menus: null
          },
        ]
      }
    ]
    
    // 只有admin角色才显示财务管理菜单
    if (userRole === 'admin') {
      menuData.push({
        menuid: 4,
        icon: 'li-icon-xitongguanli',
        menuname: '财务管理',
        hasThird: null,
        url: null,
        menus: [
          {
            menuid: 41,
            icon: 'icon-cus-manage',
            menuname: '提现管理',
            hasThird: 'N',
            url: '/money/Withdrawal',
            menus: null
          },
          {
            menuid: 42,
            icon: 'icon-cms-manage',
            menuname: '用户卡信息',
            hasThird: 'N',
            url: '/money/Card',
            menus: null
          }
        ]
      })
    }
    
    this.allmenu = menuData
    // 监听
    this.$root.Bus.$on('toggle', value => {
      this.collapsed = !value
    })
  }
}
</script>
<style>
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 240px;
  min-height: 400px;
}
.el-menu-vertical-demo:not(.el-menu--collapse) {
  border: none;
  text-align: left;
}
.el-menu-item-group__title {
  padding: 0px;
}
.el-menu-bg {
  background-color: #1f2d3d !important;
}
.el-menu {
  border: none;
}
.logobox {
  height: 40px;
  line-height: 40px;
  color: #9d9d9d;
  font-size: 20px;
  text-align: center;
  padding: 20px 0px;
}
.logoimg {
  height: 40px;
}
</style>


// WEBPACK FOOTER //
// src/components/leftnav.vue